'use client';

import { useApi } from '@prismo-io/core';
import type { SWRArgs, ToolsOrganizationsT } from '@prismo-io/schemas';
import useSWRMutation from 'swr/mutation';
import { createOrganization } from './create-organization';
import type { CreationSchemaT } from './schema';

export const useCreateOrganization = () => {
  const { client } = useApi();

  return useSWRMutation(
    ['create-organization'],
    async (key, { arg }: SWRArgs<CreationSchemaT>) => {
      const result = await createOrganization(client, arg);

      return result as ToolsOrganizationsT;
    }
  );
};
